import { render } from "./Navbar-Startup.vue?vue&type=template&id=51b7a085&scoped=true"
import script from "./Navbar-Startup.vue?vue&type=script&lang=js"
export * from "./Navbar-Startup.vue?vue&type=script&lang=js"

import "./Navbar-Startup.vue?vue&type=style&index=0&id=51b7a085&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51b7a085"]])

export default __exports__